export enum FEEDBACK {
	COURSE = 'course',
	VOTE= 'vote',
	MENTOR= 'mentor',
}